import { cn, getRiskBg } from "@/lib/utils";

interface ScoreBadgeProps {
  score: number | null;
  riskLevel: string | null;
}

export function ScoreBadge({ score, riskLevel }: ScoreBadgeProps) {
  if (score === null || riskLevel === null) {
    return <span className="text-xs text-slate-400">--</span>;
  }

  return (
    <span className={cn("inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs font-medium border", getRiskBg(riskLevel))}>
      {score}
    </span>
  );
}
